export var formatNumber = function(value) {
    return value.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

//# sourceMappingURL=formatNumber.js.map